<template>
    <v-layout column style="height: 100%;">
        <v-flex >
            <v-layout>
                <top-info-panel >
                    <v-flex xs12 md12 lg8 xl5 px-2  slot="content" >
                        <v-layout row>
                            <v-tooltip bottom> 
                                <v-btn slot="activator" color="accent" fab class="btn-edit-asset mr-4" @click="configureMode = true" v-show="!configureMode"> <v-icon>edit</v-icon></v-btn>
                                <span>Ga naar meldingen configuratie</span>                            
                            </v-tooltip>
                            <v-tooltip bottom> 
                                <v-btn  slot="activator" color="accent" fab class="btn-edit-asset mr-4" @click="configureMode = false" v-show="configureMode"> <v-icon class="fas fa-undo"></v-icon></v-btn>                        
                                <span>Ga terug naar meldingcentrum</span>                            
                            </v-tooltip>                                
                            <v-flex xs10 justify-center style="z-index:1000;" v-show="!configureMode">
                                <h4>Meldingencentrum</h4>
                                <p>In het meldingencentrum kunt u de berichten beheren en instellen. Zowel voor gebruikersberichten als voor de systeemberichten.</p>
                            </v-flex>
                            <v-flex xs10 justify-center style="z-index:1000;" v-show="configureMode">
                                <h4>Meldingen configuratie</h4>
                                <p>Bij meldingen configuratie kunt u instellen wanneer een melding verzonden moet worden en wie deze meldingen moet ontvangen.</p>
                            </v-flex>                            
                        </v-layout>
                    </v-flex>
                </top-info-panel> 
            </v-layout> 
        </v-flex>
        <v-flex v-if="configureMode==true" style="height: 100%;" class="animated fadeIn">
            <v-layout style="height:100%">                  
                <notification-configuration></notification-configuration>
            </v-layout>
        </v-flex>
        <v-flex v-if="configureMode==false" style="height: 100%;" class="animated fadeIn">
            <v-layout style="height:100%">
                <v-flex sm12 md6 lg3 style="border-right: 1px solid #ddd;" class="height-100 mini-scroll" >
                    <vue-perfect-scrollbar class="drawer-menu--scroll" :settings="scrollSettings">                    
                        <v-list subheader>
                            <v-subheader>Systeemberichten</v-subheader>
                            <v-list-tile                            
                                avatar
                                @click="selectExternalApplication(null)"
                                :class="{'grey lighten-3': (selectedApplication == null)}"
                            >
                                <v-list-tile-avatar color="accent lighten-2 ">
                                <v-icon color="white">fas fa-comments-alt</v-icon>
                                </v-list-tile-avatar>

                                <v-list-tile-content>
                                <v-list-tile-title >Alle systeemberichten</v-list-tile-title>
                                </v-list-tile-content>

                                <v-list-tile-action>
                                <div class="dd-badge accent">{{totalSystemMessages}}</div>
                                </v-list-tile-action>
                            </v-list-tile>
                            <v-list-tile
                                v-for="item in sortedOveralSystemNotificationsMeta"
                                :key="item.name"
                                avatar
                                :class="{'grey lighten-3': (selectedApplication && selectedApplication.id == item.id)}"
                                @click="selectExternalApplication(item)"
                            >
                                <v-list-tile-avatar > 
                                  <img :src="item.avatar">
                                </v-list-tile-avatar>

                                <v-list-tile-content>
                                <v-list-tile-title v-html="item.name"></v-list-tile-title>
                                </v-list-tile-content>

                                <v-list-tile-action>
                                <div class="dd-badge accent">{{item.total}}</div>
                                </v-list-tile-action>
                            </v-list-tile>
                        </v-list>    
                        <v-list subheader>                        
                            <v-subheader>Chatberichten</v-subheader>
                            
                            <v-list-tile
                                v-for="item in userMessagesMeta"
                                :key="item.id"
                                avatar
                                :class="{'grey lighten-3': (selectedUser && selectedUser.id == item.id)}"
                                @click="selectUser(item)"
                            >
                                <v-list-tile-avatar>
                                    <dd-avatar
                                        :user="item"
                                    ></dd-avatar>
                                    <div v-if="userIsOnline(item.id)" class="dd-user-badge dd-user-online"></div>
                                    <div v-else class="dd-user-badge dd-user-offline"></div>
                                <!-- <img :src="item.avatar"> -->
                                </v-list-tile-avatar>

                                <v-list-tile-content>
                                    <v-list-tile-title >{{item.person.firstName}} {{item.person.lastName}}</v-list-tile-title>
                                </v-list-tile-content>

                                <v-list-tile-action>
                                <div class="dd-badge accent" v-if="item.messageAmount">{{item.messageAmount}}</div>
                                </v-list-tile-action>
                            </v-list-tile>
                        </v-list>       
                    </vue-perfect-scrollbar>                                 
                </v-flex>        
                <v-flex sm12 md6 lg3 v-if="!selectedUser" class="height-100 mini-scroll">                    
                    <v-layout column style="border-right: 1px solid #ddd;">
                        <v-flex v-if="selectedApplication"  grey lighten-3 px-2 py-2 class="message-list-header">
                            Berichten vanuit {{selectedApplication.name}}
                        </v-flex>
                         <v-flex v-else grey lighten-3 px-2 py-2 class="message-list-header">
                            Alle systeemberichten
                        </v-flex>
                        <v-flex >
                            <v-list three-line>
                                <template v-for="(item,index) in systemMessages" >              
                                <v-list-tile    
                                    v-if="getExternalApplication(item.externalApplicationId)"
                                    :key="item.key"
                                    avatar 
                                    @click="selectMessage(item)"    
                                    class="dd-message-type"                               
                                    :class="{'grey lighten-3': (selectedMessage && selectedMessage.id == item.id)}"                                    
                                    :style="`border-left-color: ${messageColor(item.eventType.internalName)} !important;`"
                                >
                                    <v-list-tile-avatar color="white" >
                                    <img :src="getExternalApplication(item.externalApplicationId).avatar">
                                    </v-list-tile-avatar>
-
                                    <v-list-tile-content>
                                    <v-list-tile-title ><strong>{{item.options.subject}}</strong></v-list-tile-title>
                                    <v-list-tile-sub-title ></v-list-tile-sub-title>
                                    <v-list-tile-sub-title ><span class='text--primary'>{{getExternalApplication(item.externalApplicationId).name}} </span> &mdash; {{item.message}}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>                  
                                    <v-list-tile-action-text>{{item.timestamp | timeAgoTwitter}} </v-list-tile-action-text>
                                    
                                    
                                    </v-list-tile-action>

                                </v-list-tile>
                                <v-divider></v-divider>
                                </template>
                            </v-list>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex sm12 md12 lg6 primary lighten-3 v-if="!selectedUser">
                    <v-layout >
                        <v-flex ma-0 mx-3 pa-3 white style="border-radius: 6px;" v-if="selectedMessage">
                            <div class="message-row">
                                <div class="message-label">Type:</div>
                                <div class="message-value " ><span class="dd-badge" :style="`background-color: ${messageColor(selectedMessage.eventType.internalName)}`">{{selectedMessage.eventType.name}}</span></div>
                            </div>
                            <div class="message-row">
                                <div class="message-label">Datum:</div>
                                <div class="message-value">{{selectedMessage.timestamp | date_nl}}</div>
                            </div>                            
                            <div class="message-row">
                                <div class="message-label">Tijdstip:</div>
                                <div class="message-value">{{selectedMessage.timestamp | time}}</div>
                            </div>   
                            
                            <div class="grey lighten-4 mt-4 pa-2" style='border-radius: 4px;'>
                                <div class="message-row" v-if="selectedMessage.options.subject">
                                    
                                    <div class="message-value" style="font-size:18px;"><strong>{{selectedMessage.options.subject}}</strong></div>
                                </div>                     
                                <div class="message-row mt-2">
                                    <v-layout>
                                        <v-flex sm12 v-if="!isDeepDigitalMessage(selectedMessage)">
                                            <div>
                                            {{selectedMessage.message}}
                                            </div>
                                            <div  v-if="selectedAsset && selectedAsset.id"   >
                                                <div class="message-info-title  mt-4">Asset informatie</div>
                                                <div class="message-extra-details blue-grey lighten-3 py-3">
                                                    <div class="message-row ">
                                                        <div class="message-label">Asset naam:</div>
                                                        <div class="message-value">{{selectedAsset.name}}</div>
                                                    </div>   
                                                    <div class="message-row">
                                                        <div class="message-label">Groep:</div>
                                                        <div class="message-value">{{selectedAsset.group.name}}</div>
                                                    </div>  
                                                    <div class="message-row">
                                                        <div class="message-label">Type:</div>
                                                        <div class="message-value">{{selectedAsset.type.name}}</div>
                                                    </div>                                                     
                                                    <template v-for="field of selectedAsset.customFields" >
                                                    <div class="message-row" :key="field.name">
                                                        <div class="message-label">{{field.name}}:</div>
                                                        <div class="message-value">{{field.value}}</div>
                                                    </div>                                                     
                                                    </template>
                                                </div>
                                            </div>
                                            
                                        </v-flex>
                                        <template v-else>
                                            <v-flex sm12 lg7 pr-2 >
                                                <div>
                                                {{selectedMessage.message}}
                                                </div>
                                                <div  v-if="selectedAsset && selectedAsset.id"   >
                                                    <div class="message-info-title  mt-4">Asset informatie</div>
                                                    <div class="message-extra-details blue-grey lighten-3 py-3">
                                                        <div class="message-row ">
                                                            <div class="message-label">Asset naam:</div>
                                                            <div class="message-value">{{selectedAsset.name}}</div>
                                                        </div>   
                                                        <div class="message-row">
                                                            <div class="message-label">Groep:</div>
                                                            <div class="message-value">{{selectedAsset.group.name}}</div>
                                                        </div>  
                                                        <div class="message-row">
                                                            <div class="message-label">Type:</div>
                                                            <div class="message-value">{{selectedAsset.type.name}}</div>
                                                        </div>                                                     
                                                        <template v-for="field of selectedAsset.customFields" >
                                                        <div class="message-row" :key="field.name">
                                                            <div class="message-label">{{field.name}}:</div>
                                                            <div class="message-value">{{field.value}}</div>
                                                        </div>                                                     
                                                        </template>
                                                    </div>
                                                </div>
                                                <div  v-if="selectedGeoZone && selectedGeoZone.id"   >
                                                    <div class="message-info-title  mt-4">POI informatie</div>
                                                    <div class="message-extra-details blue-grey lighten-3 py-3">
                                                        <div class="message-row ">
                                                            <div class="message-label">Asset naam:</div>
                                                            <div class="message-value">{{selectedGeoZone.name}}</div>
                                                        </div>   
                                                        <div class="message-row ">
                                                            <div class="message-label">Assets aanwezig:</div>
                                                            <div class="message-value">{{selectedGeoZone.assetAmount}}</div>
                                                        </div>        
                                                        <template v-for="field of selectedGeoZone.customFields" >
                                                        <div class="message-row" :key="field.name">
                                                            <div class="message-label">{{field.name}}:</div>
                                                            <div class="message-value">{{field.value}}</div>
                                                        </div>                                                     
                                                        </template>
                                                    </div>
                                                </div>
                                                
                                                
                                            </v-flex>
                                            <v-flex sm12 lg5 v-if="selectedMessage.options.lat && selectedMessage.options.lon" style="padding: 0px 0px;">
                                                <l-map
                                                    :zoom="zoom"
                                                    :options="mapOptions"
                                                    
                                                    :center="[selectedMessage.options.lat, selectedMessage.options.lon]"
                                                    style="min-height:300px;"
                                                >
                                                    <!-- <l-group >
                                                        <l-polygon 
                                                            :color="zoneColor(geoZoneTypeId)"
                                                            :fillColor="zoneColor(geoZoneTypeId)"
                                                            :lat-lngs="zoneCoordinates(geoZone)"                               
                                                        >
                                                        </l-polygon>
                                                    </l-group>    -->
                                                    
                                                    <l-marker
                                                        v-if="selectedAsset && selectedAsset.id"                                                                                                             
                                                        :latLng="[selectedMessage.options.lat, selectedMessage.options.lon]"                                                        
                                                        :icon="genericLocationIcon({color: accentColor, icon: selectedAsset.group.icon})"
                                                        @click="debugDump(selectedAsset)"
                                                    >
                                                    </l-marker>
                                                     <l-polygon v-if="selectedGeoZone" 
                                                        :color="accentColor"
                                                        :fillColor="accentColor"
                                                        :lat-lngs="zoneCoordinates"                               
                                                    >
                                                    </l-polygon>

                                                    <l-tilelayer :url="url" :attribution="attribution"></l-tilelayer>
                                                    <l-control-zoom position="topright"></l-control-zoom>
                                                </l-map>
                                            </v-flex>
                                        </template>
                                        
                                    </v-layout>                                                                            
                                </div>
                            </div>
                            <div class="message-row mt-2 message-link d-flex"  v-if="isDeepDigitalMessage(selectedMessage)">
                                <ul class="dd-message-links">
                                    <li v-if="selectedMessage.options.assetId"><div><i class="far fa-globe-europe accent--text" style="font-size:16px;margin-right:6px;" v-if="selectedMessage.options.assetId"></i></div><a href="#" @click="showAssetOnMap(selectedMessage.options.assetId)">Toon live op kaart</a></li>
                                    <li v-if="selectedMessage.options.assetId"><div><i class="far fa-satellite-dish accent--text" style="font-size:16px;margin-right:6px;" v-if="selectedMessage.options.assetId"></i></div><a href="#" @click="showAssetDossier(selectedMessage.options.assetId)">Toon asset dossier</a></li>
                                    <li v-if="selectedMessage.options.geoZoneId"><div><i class="far fa-map-marked-alt accent--text" style="font-size:16px;margin-right:6px;" v-if="selectedMessage.options.assetId"></i></div><a href="#" @click="showLocationDossier(selectedMessage.options.geoZoneId)">Toon POI dossier</a></li>
                                </ul>
                                <!-- <v-layout column>
                                    <v-flex></v-flex>
                                    <v-flex><i class="far fa-globe accent--text" style="font-size:16px;margin-right:6px;" v-if="selectedMessage.options.assetId"></i><a :href="`${selectedMessage.options.url}`">Open asset dossier</a></v-flex>
                                    <v-flex><i class="far fa-globe accent--text" style="font-size:16px;margin-right:6px;" v-if="selectedMessage.options.assetId"></i><a :href="`${selectedMessage.options.url}`">Open POI dossier</a></v-flex>
                                </v-layout> -->
                            </div>
                            
                            <div class="message-row mt-2 message-link"  v-if="selectedMessage.options.url">
                                <i class="far fa-globe accent--text" style="font-size:16px;margin-right:6px;"></i><a :href="`${selectedMessage.options.url}`">{{selectedMessage.options.url}}</a>
                            </div>
                            <v-divider></v-divider>
                            <div class="message-row mt-2 message-tags" v-if="selectedMessage.options.tags">
                                <v-chip v-for="(tag, i) in selectedMessage.options.tags" :key="i" color="purple" text-color="white">
                                    {{tag}}
                                </v-chip>
                            </div>
                        </v-flex>
                        <div class="no-message-selected primary--text" v-else>
                            <i class="far fa-comment-alt-slash"></i>                            
                            <span class="primary--text">Selecteer een bericht</span>
                        </div>
                    </v-layout>
                </v-flex>
                <v-flex sm-12 v-if="selectedUser" primary lighten-2 class="chat-background" pt-5>
                    <v-layout justify-center >
                        <v-flex sm11 md11 lg8 xl6  white class="dd-chatbox" >
                            <v-flex primary lighten-1 white--text py-2 px-2 style="border-bottom: 1px solid #000;">                                
                                Chat met {{selectedUser.person.firstName}} {{selectedUser.person.lastName}}
                            </v-flex>
                            <v-flex py-0 px-0 v-if="currentUser && selectedUser && userMessages.length > 0" class="dd-message-list"  v-chat-scroll>
                                <template v-for="(message, i) of userMessages"   v-chat-scroll>
                                    <div class="dd-message-date-divider" v-if="isNewDate(message,i)" >
                                        <div></div>
                                        <div class="date">{{message.timestamp | date_nl }}</div>
                                        <div></div>
                                    </div>
                                    <dd-chat-message
                                        :key="message.id"
                                        v-if="message.fromUserId == currentUser.id"
                                        direction="sent"
                                        class="px-2 py-2"
                                        :user="currentUser"
                                        :message="message.message"
                                        :timestamp="message.timestamp"
                                    ></dd-chat-message>
                                    <dd-chat-message
                                        :key="message.id"
                                        v-else
                                        direction="received"
                                        class="px-2 py-2"
                                        :user="selectedUser"
                                        :message="message.message"
                                        :timestamp="message.timestamp"
                                    ></dd-chat-message>
                                </template>
                                
                                                             
                            </v-flex>
                            <v-flex v-else class="dd-start-new-conversation">
                                    <i class="far fa-comment-dots" style="font-size: 40px; opacity:0.5;"></i><br>
                                    Stuur een bericht om een gesprek met {{selectedUser.person.firstName}} te starten!
                                </v-flex>
                            <v-flex grey lighten-3 mt-3 pt-2 px-2 style="height:66px;" >
                                    <v-layout>
                                        <v-flex style="width: 100%;">
                                            <v-text-field
                                                solo
                                                :placeholder="`Typ een bericht naar ${selectedUser.person.firstName}...`"
                                                style="margin-bottom:0; padding:bottom:0;"
                                                @keyup.native="keyHit"
                                                v-model="messageText"

                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex style="width:40px;" class="mr-2">                                            
                                            <v-btn flat icon><v-icon class="far fa-paper-plane" @click="sendMessage()"></v-icon></v-btn>
                                        </v-flex>
                                    </v-layout>                                    
                                </v-flex>   
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>
<script>
import * as types from '../../store/types'
import { mapGetters } from 'vuex'
import moment from 'moment'
import ColorMixin from '../../plugins/mixins/ColorMixin'
import MapMixin from '../../plugins/mixins/MapMixin'
import DdAvatar from '../../components/global/DdAvatar'
import DdChatMessage from '../../components/global/DdChatMessage'
import TopInfoPanel from '../../components/global/TopInfoPanel'
import NotificationConfiguration from '../../components/notifications/NotificationConfiguration'
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default{
    
    components:{TopInfoPanel, DdAvatar, DdChatMessage,VuePerfectScrollbar, NotificationConfiguration},
    mixins: [ColorMixin, MapMixin],
    data(){
        return {
            configureMode:false,
            selectedApplication: null,
            messagesPerPage: 20,
            selectedMessage: null,
            messageText: '',
            scrollSettings: {
                maxScrollbarLength: 160
            },
            zoom: 15
            //usersOnline: null
            //selectedUser: null,            
        }
    },
    computed:{
        ...mapGetters({
            overalSystemNotificationsMeta: types.OVERAL_SYSTEM_MESSAGES_META,
            mainMenuShown: types.MAIN_MENU_SHOWN,
            currentUser: types.CURRENT_USER,     
            systemMessages: types.SYSTEM_MESSAGES,
            systemMessagesMeta: types.SYSTEM_MESSAGES_META,
            selectedAsset: types.ASSET,   
            selectedGeoZone: types.GEO_ZONE,
            userMessagesMeta: types.USER_MESSAGES_META,
            userMessages: types.USER_MESSAGES,
            selectedUser: types.USER,
            usersOnline: types.USERS_ONLINE
        }),
        sortedOveralSystemNotificationsMeta(){
            if(this.overalSystemNotificationsMeta && this.overalSystemNotificationsMeta.length > 0){
                return this.overalSystemNotificationsMeta.sort((a,b) => b.total - a.total)                                
            }
            else{
                return null
            }
        },
        totalSystemMessages(){
            let totals = 0;
            if(this.overalSystemNotificationsMeta){
                for(let [i, item] of Object.entries(this.overalSystemNotificationsMeta)){                    
                    totals  = totals + item.total                    
                }                            
            }
            return totals

        },
        zoneCoordinates(){            
            console.log(this.selectedGeoZone)
            if(this.selectedGeoZone && this.selectedGeoZone.geopoly && this.selectedGeoZone.geopoly.coordinates){
                let poly = this.geojsonCoordinatesToPoly(this.selectedGeoZone.geopoly.coordinates)
                console.log("POLY:",poly)
                return poly
            }
            return []
        }      
    },
    methods:{
        debugDump(a){
            console.log(a)
        },
        userIsOnline(id){
            if(this.usersOnline && this.usersOnline.length > 0){                
                let u = this.usersOnline.find((ele) => ele.id == id)
                if(u){
                    return true
                }
                return false
            }            
            return false            
        },
        isNewDate(message1, index){
            if(index == 0){
                return true
            }
            let date1 = moment(message1.timestamp)
            let date2 = moment(this.userMessages[index - 1].timestamp)

            if(date1.format("YYYYMMDD") != date2.format("YYYYMMDD")){
                return true
            }
            return false            
        },
        keyHit(e){                
            if(e.keyCode == 13){
                this.sendMessage()
            }
        },
        sendMessage(){
            if(this.messageText.length > 0){
                let vm = this
                this.$store.dispatch(types.SEND_USER_MESSAGE, {
                    data: {
                        toUserId: this.selectedUser.id,
                        message: this.messageText
                    }
                }).then(() => {
                    vm.messageText = ''
                    //vm.getUserMessages(vm.selectedUser)
                })
            }
        },
        showAssetOnMap(assetId){            
            let url = this.$router.resolve({name: 'AssetMap', query: { assetId }})            
            window.open(url.href, '_blank')            
        },
        showAssetDossier(assetId){
            let url = this.$router.resolve({name: 'AssetDetails', })             
            window.open(`/asset-details/${assetId}`, '_blank')
        },
        showLocationDossier(locationId){

        },
        getUserMessages(u){
            let p = new Promise((resolve, reject) => {
                this.$store.dispatch(types.USER_MESSAGES, {
                    data:{
                        userId: u.id
                    },
                    params: {
                        include: '',
                        per_page: 200
                    }
                }).then(() => {
                    resolve()
                })
            })
            return p            
        },
        selectUser(u){
            //this.selectedUser = u            
            let vm = this
            
            this.getUserMessages(u).then(() => {
                vm.$store.dispatch(types.USER, {data: {id: u.id}, params: {include: 'person,avatar'}})
            })
        },
        selectMessage(message){
            console.log("SELECTED: ", message)
            this.$store.commit(types.GEO_ZONE, {})
            this.$store.commit(types.ASSET, {})

            if(message.options.geoZoneId){
                console.log("This message has a location")                
                this.$store.dispatch(types.GEO_ZONE, { data: { id: message.options.geoZoneId }, params: { include: 'group,type'}})
            }

            if(message.options.assetId){                
                this.$store.dispatch(types.ASSET, { data: { id: message.options.assetId }, params: { include: 'group,type'}})

                
                console.log("This message has an asset")
            }

            this.selectedMessage = message
            window.scrollTo(0,0);


        },
        isDeepDigitalMessage(message){
            let app = this.getExternalApplication(message.externalApplicationId)
            
            if(app && app.name == 'DeepDigital'){
                return true
            }
            return false
        },
        messageColor(message){                        
            return this.color(message)            
        },
        selectExternalApplication(app){            
            let vm = this
            vm.$store.dispatch(types.USER, null)
            if(app !== null) {
                this.loadApplicationMessages(app.id).then(() => {
                    vm.selectedApplication = app
                })
            }
            else{
                this.loadAllSystemMessages()
                vm.selectedApplication = null
            }
            
        },
        loadApplicationMessages(id){
            let p = new Promise((resolve, reject) => {            
                this.$store.dispatch(types.APPLICATION_SYSTEM_MESSAGES, {
                    data: {
                        applicationId: id,
                    },
                    params:{
                        per_page: this.messagesPerPage, 
                        include: 'eventType'  
                    }
                }).then(() => {
                    resolve()
                })
            })
            return p
        },
        loadAllSystemMessages(){
            this.selectedApplication = null
            this.$store.dispatch(types.SYSTEM_MESSAGES, {params: { per_page: this.messagesPerPage, include: 'eventType'}})

        },
        getExternalApplication(id){
            let app = null
            if(this.overalSystemNotificationsMeta){
                app = this.overalSystemNotificationsMeta.find((ele) => ele.id == id)
            }
            
            return app            
        }


    },
    beforeDestroy(){
          
    },
    mounted(){
        this.loadAllSystemMessages()
        this.$store.dispatch(types.OVERAL_SYSTEM_MESSAGES_META, {})        
        this.$store.dispatch(types.USER_MESSAGES_META, {params:{ include: 'person,avatar', per_page: 100}})
        //console.log("BINDING PRESENCE EVENT!", this.$pusher.channels['presence-user-channel'].members.members)
        let vm = this

        // vm.usersOnline = vm.$pusher.channels['presence-user-channel'].members.members;
        
        // vm.$pusher.channels['presence-user-channel'].bind_global(function (event, data) {                       
        //    vm.usersOnline = []
        //    Object.entries(vm.$pusher.channels['presence-user-channel'].members.members).forEach(item => {
        //        //console.log(item)
        //         vm.usersOnline.push(item[1])
        //    })
           
        //    //vm.usersOnline = vm.$pusher.channels['presence-user-channel'].members.members
        //    //console.log("PRESENCE CHANNEL EVENT: ", vm.$pusher.channels['presence-user-channel'])
        // })     
    }
}
</script>
<style>
.message-list-header{
    font-size: 16px;
}

.no-message-selected{
    justify-content: center;
    text-align: center;
    display: flex;    
    margin-top: calc(50vh - 80px);
    width: 100%;
    flex-direction: column;    
}

.no-message-selected i{
    font-size: 60px;
}

.no-message-selected span{
    font-size: 24px;
}

.dd-message-type{
    border-left: 6px solid;
    margin-left:6px;
    margin-right:6px;
    margin-top:8px;
    margin-bottom:8px;
    border-radius: 4px;
}

.message-row{
    width: 100%;
    display: flex;
    
}

.message-row div{
    padding: 0px 2px;
}

.message-label{
    width: 140px;
    font-weight: 600;
    text-align: right;
    margin-right: 4px;
}

.message-value{
    display: flex;
    flex:1;
    align-content: flex-end;
    align-items: flex-end;
}
.message-info-title{
    text-transform: uppercase;
    
    font-size: 17px;
}

.message-extra-details{
    border-radius: 6px; 
    
}

.message-link{
    display: flex; 
    align-items:center; 
    align-content: center;
    
    padding: 4px 0px;
}
.message-container{
    flex: 0;
    /* height: 100vh - 200px; */
    height: calc(90vh);
    overflow-y:scroll;
}

.dd-message-links{
    list-style: none;
    list-style-position: outside;
    padding-left: 4px;
}

.dd-message-links li{
    display: flex;
}


.dd-message-links a {
    text-decoration: none;
}

.dd-message-links a:hover {
    color: #ff5722;
}

.dd-message-links div{
    width: 30px;
    text-align: center;
}

.chat-background{
    background-image: url("../../assets/images/chat-background.png"); 
    background-repeat: repeat;     
}

.dd-message-date-divider{
    display: flex;
    width: 100%;
}

.dd-message-date-divider div{
    flex:1;
    padding: 10px 0px;
    margin: 0px 10px;
    background: linear-gradient(180deg, 
        rgba(0,0,0,0) calc(50% - 1px), 
        rgba(192,192,192,1) calc(50%), 
        rgba(0,0,0,0) calc(50% + 1px)
    );
}

.dd-message-date-divider .date{
    max-width: 100px;

    text-align: center;
    background: none;
}

.dd-chatbox{
    
    overflow-y:hidden;
}

.dd-message-list{
    max-height: calc(80vh - 250px) !important;
    overflow-y: auto;
}

.dd-start-new-conversation{
    margin: 4px 28px;
    padding: 10px 2px;
    margin-top: 20px;
    background-color: #ddd;
    border-radius: 5px;
    text-align: center;
}

.dd-user-badge {
    position: absolute;
    height: 20px;
    width: 20px;
    border: 4px solid #fff;
    border-radius: 50%;
    margin-left: 20px;
    margin-top: -10px;
}

.dd-user-offline{
    background-color: #ccc;
}

.dd-user-online{
    background-color: #00b08b;
}

.height-100{
    height: calc(100vh - 230px);
    overflow-y:scroll;
    
}


</style>